import axios, { AxiosRequestConfig, AxiosResponse } from 'axios'

import { ApiResult } from './apiTypes'

type HttpMethod = 'GET' | 'POST' | 'PATCH' | 'PUT' | 'DELETE' | 'OPTIONS'

export type WithIParam<T extends Record<string, unknown>> = T & IParam

export interface IParamOrderBy extends Omit<IParam, '_sort' | '_order'> {
  orderBy?: string
}

export interface IParamForSubmit
  extends Omit<
    IParam,
    'q' | 'id' | '_page' | '_limit' | '_sort' | 'searchColumns'
  > {
  q?: string | number
  id?: string | number
  _page?: string | number
  _limit?: string | number
  _sort?: string | number
  searchColumns?: string[]
}

export interface IParam {
  q?: string
  id?: string
  _page?: string | number
  _limit?: string | number
  _sort?: string
  _order?: 'ASC' | 'DESC'
  isActive?: string | boolean
  code?: string
  redirectUrl?: string
  searchColumns?: string[]
}

export interface IParamQuery {
  q?: string
  id?: string | number
  _ids?: string[] | number[]
  _page?: number
  _limit?: number
  _sort?: string
  _order?: 'ASC' | 'DESC'
  status?: boolean | string
  code?: string
  redirectUrl?: string
}

export interface IFetchAPI<P> {
  apiUrl?: string
  method: HttpMethod
  options?: AxiosRequestConfig
  path: string
  timeout?: number
  params?: IParamForSubmit & P
  responseType?: 'blob' | 'stream'
}

export async function fetchAPI<
  T,
  P = IParamForSubmit & { [key: string]: unknown },
>(props: IFetchAPI<P>): Promise<ApiResult<T>> {
  const {
    apiUrl = window._env_.REACT_APP_API_URL,
    method,
    path,
    timeout,
    options,
    responseType,
    params,
  } = props
  const response: AxiosResponse = await axios({
    baseURL: apiUrl + path,
    method,
    timeout,
    params,
    responseType,
    ...options,
  })

  return {
    status: response.status,
    body: response.data,
    headers: response.headers,
  }
}
